import { parseCalendarDate } from "./forms/dateField";

export const validateEmail = (email: string) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  );

export const validateBirthdate = (value: string) => {
  const birth = parseCalendarDate(value);
  if (!birth) return false;
  const today = new Date();
  const todayStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  return birth.getTime() <= todayStart.getTime();
};

export const validatePhone = (value: string) =>
  value.replace(/\D/g, "").length === 11;

export const validateRequired = (value: string) => Boolean(value.length);
